import $ from 'gridstrap/lib/gs-zepto';


export class GSHamburgerMenu {

	//
	// Properties
	//

	private root;
	private events: any = {};

	//
	// Methods
	//

	click() {
		const isOpen = this.root.hasClass('gs-HamburgerMenu--open');
		this.trigger('click', { isOpen: !isOpen });
		isOpen ? this.markAsClosed() : this.markAsOpened();
	}

	markAsOpened() {
		this.root.addClass('gs-HamburgerMenu--open');
	}

	markAsClosed() {
		this.root.removeClass('gs-HamburgerMenu--open');
	}

	on(name, fn) {
		this.events[name] ??= [];
		this.events[name].push(fn);
	}

	private trigger(name, params?) {
		this.events[name]?.forEach((fn) => fn(params));
	}

	//
	// Initialization
	//

	constructor(root) {
		this.root = $(root);
	}

	gsOnInit() {
		this.root.on('click', () => this.click());
	}
}
